import React from 'react';
import PropTypes from 'prop-types';
import TagButtonGroup from './TagButtonGroup';

export default function DesignMetadata({ design }) {
    return (
        <div>
            <div dangerouslySetInnerHTML={{ __html: design.description }} />
            <div className="fullscreen__sidebar__tags">
                <TagButtonGroup tags={design.tags} />
            </div>
        </div>
    );
}

DesignMetadata.propTypes = {
    design: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/DesignMetadata.jsx